import type { Box3 } from 'three'
import type { TilesCollisionRuntime } from '@/plugins/tiles/runtime/TilesCollisionRuntime'
import type { TilesRuntime } from '@/plugins/tiles/runtime/TilesRuntime'
import type { TilesetHandle } from '@/plugins/tiles/types'

/** 固定资产描述与 Record 自有运行时；局部范围不随 LRU 驻留变化。 */
export class TilesetRecord {
  mounted = false
  collision?: TilesCollisionRuntime
  constructor(
    readonly handle: TilesetHandle,
    readonly localBounds: Box3,
    readonly runtime: TilesRuntime,
    readonly rootReadyMs: number,
    readonly hasSourceBounds: boolean,
    readonly warnings: readonly string[]
  ) {}
}
